import { BillingInfoText } from "../BillingInformation-types";
/**
 * Column configuration for credit card table
 */
export const CREDIT_CARD_COLUMN_METADATA = {
    cardImage: {
        label: BillingInfoText.CC_TABLE_HEADER_CARD,
        minWidth: 80,
        align: "center",
        order: 1,
    },
    last4: {
        label: BillingInfoText.CC_TABLE_HEADER_LAST4,
        minWidth: 120,
        align: "left",
        order: 2,
    },
    expiration: {
        label: BillingInfoText.CC_TABLE_HEADER_EXP,
        minWidth: 100,
        align: "left",
        order: 3,
    },
    isPrimary: {
        label: BillingInfoText.CC_TABLE_HEADER_PRIMARY,
        minWidth: 100,
        align: "center",
        order: 4,
    },
    actions: {
        label: BillingInfoText.CC_TABLE_HEADER_ACTIONS,
        minWidth: 150,
        align: "center",
        order: 5,
    },
};
